import { Box } from "@mantine/core";

import classes from "../chat-components.module.css";

/**
 * Indicator that shows a colored vertical bar when a chat is selected.
 * Uses absolute positioning to fill the parent container's height.
 */
export const SelectedChatIndicator = ({ isChatSelected }: { isChatSelected: boolean }) => (
    <Box className={classes.selected_chat_box} mod={{ selected: isChatSelected }} />
);
